import _extends from "@babel/runtime/helpers/extends";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { BasicTooltip } from '@livable/saas-react-components';
import { Button, TextField, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { observer } from 'mobx-react-lite';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useStore } from 'src/stores';
import useAllocationUtilityStyles from '../styles';
const TableModal = observer(_ref => {
  let allocations = _ref.allocations;
  const classes = useAllocationUtilityStyles();
  const store = useStore();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  const _useState = useState(10),
    _useState2 = _slicedToArray(_useState, 2),
    pageSize = _useState2[0],
    setPageSize = _useState2[1];
  const renderCell = (parameter, left) => /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
  }, parameter);
  const renderHeader = (text, rightAlign) => /*#__PURE__*/React.createElement("span", {
    className: rightAlign && classes.rightAlign
  }, text);
  const renderCellTooltip = (parameter, left) => /*#__PURE__*/React.createElement("div", {
    className: classes.overflowCellWrapper
  }, /*#__PURE__*/React.createElement(BasicTooltip, {
    title: parameter,
    placement: "top",
    hideOnMobile: true
  }, /*#__PURE__*/React.createElement("span", {
    className: "".concat(classes.cellContent, " ").concat(left && classes.cellLeft)
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "body1",
    className: classes.overflowCell
  }, parameter))));
  const columns = [{
    field: 'unitName',
    align: 'right',
    flex: 1,
    maxWidth: 100,
    headerName: 'Unit name',
    renderCell: params => renderCellTooltip(params.row.unitName, true),
    renderHeader: () => renderHeader(t('allocations.unit_name')),
    sortComparator: (v1, v2) => {
      var _ref2;
      return (_ref2 = '' + v1) === null || _ref2 === void 0 ? void 0 : _ref2.localeCompare(v2, undefined, {
        numeric: true
      });
    }
  }, {
    field: 'residentId',
    align: 'right',
    flex: 1,
    headerName: 'Resident name',
    minWidth: 240,
    renderCell: params => {
      if (params.row.residentAccountId) {
        return renderCell(store.account.profilesFullName.get(params.row.residentAccountId), params.row.periods);
      } else {
        return renderCell(t('allocations.not_enrolled'), true);
      }
    },
    renderHeader: () => renderHeader(t('allocations.resident_name'))
  }, {
    field: 'occupantsCount',
    align: 'right',
    flex: 1,
    headerName: 'Number of occupants',
    headerAlign: 'right',
    renderCell: params => renderCell(params.row.occupantsCount),
    renderHeader: () => renderHeader(t('allocations.number_of_occupants'), true)
  }, {
    field: 'commonAreaDeduction',
    align: 'right',
    flex: 1,
    headerAlign: 'right',
    headerName: 'Unit occ. factor',
    renderCell: params => renderCell(params.row.occupancyFactor),
    renderHeader: () => renderHeader(t('allocations.unit_occ_factor'), true)
  }, {
    field: 'daysOccupied',
    align: 'right',
    flex: 1,
    headerAlign: 'right',
    headerName: 'Days lived',
    renderCell: params => renderCell(params.row.daysOccupied),
    renderHeader: () => renderHeader(t('allocations.days_number'), true)
  }, {
    field: 'allocationCharge',
    align: 'right',
    flex: 1,
    headerAlign: 'right',
    headerName: 'Allocated charge',
    renderCell: params => /*#__PURE__*/React.createElement("div", {
      className: classes.cellContent
    }, /*#__PURE__*/React.createElement(Typography, {
      variant: "body1"
    }, "$", params.row.allocationCharge)),
    renderHeader: () => renderHeader(t('allocations.allocated_charge'), true)
  }];
  return /*#__PURE__*/React.createElement(DataGrid, {
    autoHeight: true,
    columns: columns,
    disableRowSelectionOnClick: true,
    getRowClassName: () => classes.row,
    getRowId: row => row.allocationId,
    rowsPerPageOptions: [5, 10, 20],
    onPageSizeChange: newPageSize => setPageSize(newPageSize),
    pagination: true,
    columnHeaderHeight: 95,
    rowHeight: 77,
    hideFooterSelectedRowCount: true,
    initialState: {
      sorting: {
        sortModel: [{
          field: 'unitName',
          sort: 'asc'
        }]
      }
    },
    pageSize: pageSize,
    rows: allocations || [],
    slotProps: {
      filterPanel: {
        filterFormProps: {
          columnInputProps: {
            variant: 'outlined'
          },
          operatorInputProps: {
            variant: 'outlined'
          }
        }
      }
    },
    slots: {
      ColumnMenuIcon: () => /*#__PURE__*/React.createElement("span", null),
      BaseButton: props => /*#__PURE__*/React.createElement(Button, _extends({}, props, {
        variant: "actionButton",
        'custom-attribute': '514-allocation-utility'
      })),
      BaseTextField: props => /*#__PURE__*/React.createElement(TextField, _extends({}, props, {
        variant: "outlined"
      }))
    }
  });
});
export default TableModal;